import constants from '@/constants'
import resgistrationAPI from '@/api/registration-api'

export default {
  state: {
    activeSubSection: constants.registration.COMPANY_INFO,
    companyPicCompletedStatus: false,
    companyInfoCompletedStatus: false,
    companyRepCompletedStatus: false,
    legalDocumentsCompletedStatus: false,
    registrationDocumentCompletedStatus: false,
    creditRequestCompletedStatus: false,
    companyContactStatus: {
      active: true,
      completed: false
    },
    companyAddressStatus: {
      active: false,
      completed: false
    },
    dealerRegistrationStatus: {
      active: false,
      completed: false
    },
    directorContactStatus: {
      active: false,
      completed: false
    },
    directorPhotoStatus: {
      active: false,
      completed: false
    },
    companyPicInfoStatus: {
      active: false,
      completed: false
    },
    dataDocumentsStatus: {
      active: false,
      completed: false
    },
    photoDocumentsStatus: {
      active: false,
      completed: false
    },
    registrationFormStatus: {
      active: false,
      completed: false
    },
    creditRequestFormStatus: {
      active: false,
      completed: false
    },
    showConfirmationFormModalStatus: false,
    companyPicData: {},
    companyInfoData: {},
    companyAddressData: {},
    shippingAddressData: {},
    appleAccountData: {},
    supportDocumentData: {},
    directorInfoData: {},
    directorAddressData: {},
    directorDocumentsData: {},
    accountInfoData: {},
    dataDocumentsData: {},
    photoDocumentsData: {},
    registrationDocumenstData: {},
    sectionTrackingData: {},
    memberInfoData: {}
  },
  getters: {
    getActiveSubSection (state) {
      return state.activeSubSection
    },
    getCompanyPicCompletedStatus (state) {
      return state.companyPicCompletedStatus
    },
    getCompanyInfoCompletedStatus (state) {
      return state.companyInfoCompletedStatus
    },
    getCompanyRepCompletedStatus (state) {
      return state.companyRepCompletedStatus
    },
    getLegalDocumentsCompletedStatus (state) {
      return state.legalDocumentsCompletedStatus
    },
    getRegistrationDocumentCompletedStatus (state) {
      return state.registrationDocumentCompletedStatus
    },
    getCreditRequestCompletedStatus (state) {
      return state.creditRequestCompletedStatus
    },
    getCompanyContactStatus (state) {
      return state.companyContactStatus
    },
    getCompanyAddressStatus (state) {
      return state.companyAddressStatus
    },
    getDealerRegistrationStatus (state) {
      return state.dealerRegistrationStatus
    },
    getDirectorContactStatus (state) {
      return state.directorContactStatus
    },
    getDirectorPhotoStatus (state) {
      return state.directorPhotoStatus
    },
    getCompanyPicInfoStatus (state) {
      return state.companyPicInfoStatus
    },
    getDataDocumentsStatus (state) {
      return state.dataDocumentsStatus
    },
    getPhotoDocumentsActiveStatus (state) {
      return state.photoDocumentsStatus
    },
    getRegistrationFormStatus (state) {
      return state.registrationFormStatus
    },
    getCreditRequestFormStatus (state) {
      return state.creditRequestFormStatus
    },
    getShowConfirmationFormModalStatus (state) {
      return state.showConfirmationFormModalStatus
    },
    getSectionTrackingData (state) {
      return state.sectionTrackingData
    },
    getMemberInfoData (state) {
      return state.memberInfoData
    },
    getCompanyInfoData (state) {
      return state.companyInfoData
    },
    getCompanyAddressData (state) {
      return state.companyAddressData
    },
    getShippingAddressData (state) {
      return state.shippingAddressData
    },
    getAppleAccountData (state) {
      return state.appleAccountData
    },
    getSupportDocumentData (state) {
      return state.supportDocumentData
    },
    getDirectorInfoData (state) {
      return state.directorInfoData
    },
    getDirectorDocumentsData (state) {
      return state.directorDocumentsData
    },
    getDirectorAddressData (state) {
      return state.directorAddressData
    },
    getCompanyPicData (state) {
      return state.companyPicData
    },
    getAccountInfoData (state) {
      return state.accountInfoData
    },
    getDataDocumentsData (state) {
      return state.dataDocumentsData
    },
    getPhotoDocumentsData (state) {
      return state.photoDocumentsData
    },
    getRegistrationDocumenstData (state) {
      return state.registrationDocumenstData
    },
    getAdditionalInfoData (state) {
      return state.additionalInfoData
    }
  },
  mutations: {
    setActiveSubSection (state, value) {
      state.activeSubSection = value
    },
    setCompanyPicCompletedStatus (state, value) {
      state.companyPicCompletedStatus = value
    },
    setCompanyInfoCompletedStatus (state, value) {
      state.companyInfoCompletedStatus = value
    },
    setCompanyRepCompletedStatus (state, value) {
      state.companyRepCompletedStatus = value
    },
    setLegalDocumentsCompletedStatus (state, value) {
      state.legalDocumentsCompletedStatus = value
    },
    setRegistrationDocumentCompletedStatus (state, value) {
      state.registrationDocumentCompletedStatus = value
    },
    setCreditRequestCompletedStatus (state, value) {
      state.creditRequestCompletedStatus = value
    },
    setCompanyContactStatus (state, value) {
      state.companyContactStatus = value
    },
    setCompanyAddressStatus (state, value) {
      state.companyAddressStatus = value
    },
    setDealerRegistrationStatus (state, value) {
      state.dealerRegistrationStatus = value
    },
    setDirectorContactStatus (state, value) {
      state.directorContactStatus = value
    },
    setDirectorPhotoStatus (state, value) {
      state.directorPhotoStatus = value
    },
    setCompanyPicInfoStatus (state, value) {
      state.companyPicInfoStatus = value
    },
    setDataDocumentsStatus (state, value) {
      state.dataDocumentsStatus = value
    },
    setPhotoDocumentsActiveStatus (state, value) {
      state.photoDocumentsStatus = value
    },
    setRegistrationFormStatus (state, value) {
      state.registrationFormStatus = value
    },
    setCreditRequestFormStatus (state, value) {
      state.creditRequestFormStatus = value
    },
    setShowConfirmationFormModalStatus (state, value) {
      state.showConfirmationFormModalStatus = value
    },
    setSectionTrackingData (state, value) {
      state.sectionTrackingData = value
    },
    setMemberInfoData (state, value) {
      state.memberInfoData = value
    },
    setCompanyInfoData (state, value) {
      state.companyInfoData = value
    },
    setAdditionalInfoData (state, value) {
      state.additionalInfoData = value
    },
    setCompanyAddressData (state, value) {
      state.companyAddressData = value
    },
    setShippingAddressData (state, value) {
      state.shippingAddressData = value
    },
    setAppleAccountData (state, value) {
      state.appleAccountData = value
    },
    setSupportDocumentData (state, value) {
      state.supportDocumentData = value
    },
    setDirectorInfoData (state, value) {
      state.directorInfoData = value
    },
    setDirectorDocumentsData (state, value) {
      state.directorDocumentsData = value
    },
    setDirectorAddressData (state, value) {
      state.directorAddressData = value
    },
    setCompanyPicData (state, value) {
      state.companyPicData = value
    },
    setAccountInfoData (state, value) {
      state.accountInfoData = value
    },
    setDataDocumentsData (state, value) {
      state.dataDocumentsData = value
    },
    setPhotoDocumentsData (state, value) {
      state.photoDocumentsData = value
    },
    setRegistrationDocumenstData (state, value) {
      state.registrationDocumenstData = value
    },
    setCompanyInfoResponse (state, companyInfoTrackingResponseDto) {
      if (companyInfoTrackingResponseDto) {
        const { infoOverAllFlag, companyContactFlag, companyAddressFlag, appleInfoFlag, supportingDocsFlag } = companyInfoTrackingResponseDto
        state.companyInfoCompletedStatus = infoOverAllFlag
        state.companyContactStatus = { completed: companyContactFlag, active: !companyContactFlag }
        state.companyAddressStatus = { completed: companyAddressFlag, active: companyContactFlag && !companyAddressFlag }
        state.dealerRegistrationStatus = { completed: supportingDocsFlag, active: appleInfoFlag && !supportingDocsFlag }
      } else {
        state.companyContactStatus = { completed: false, active: true }
      }
    },
    resetState (state) {
      const initialState = {
        activeSubSection: constants.registration.COMPANY_INFO,
        companyPicCompletedStatus: false,
        companyInfoCompletedStatus: false,
        companyRepCompletedStatus: false,
        legalDocumentsCompletedStatus: false,
        registrationDocumentCompletedStatus: false,
        creditRequestCompletedStatus: false,
        companyContactStatus: {
          active: true,
          completed: false
        },
        companyAddressStatus: {
          active: false,
          completed: false
        },
        dealerRegistrationStatus: {
          active: false,
          completed: false
        },
        directorContactStatus: {
          active: false,
          completed: false
        },
        directorPhotoStatus: {
          active: false,
          completed: false
        },
        companyPicInfoStatus: {
          active: false,
          completed: false
        },
        dataDocumentsStatus: {
          active: false,
          completed: false
        },
        photoDocumentsStatus: {
          active: false,
          completed: false
        },
        registrationFormStatus: {
          active: false,
          completed: false
        },
        creditRequestFormStatus: {
          active: false,
          completed: false
        },
        showConfirmationFormModalStatus: false,
        companyPicData: {},
        companyInfoData: {},
        companyAddressData: {},
        shippingAddressData: {},
        appleAccountData: {},
        supportDocumentData: {},
        directorInfoData: {},
        directorAddressData: {},
        directorDocumentsData: {},
        accountInfoData: {},
        dataDocumentsData: {},
        photoDocumentsData: {},
        registrationDocumenstData: {},
        sectionTrackingData: {},
        memberInfoData: {},
        additionalInfoData: {}
      }
      Object.assign(state, initialState)
    }
  },
  actions: {
    GET_ACCOUNT_REGISTRATION_SUMMARY ({ commit }, { query, success, fail }) {
      resgistrationAPI.getAccountRegistrationSummary(query).then(res => {
        const { companyContactResponseDto, companyAddressResponseDto, shippingAddressResponse, appleAccountResponseDto, directorInformationResponseDto, directorDocumentsResponseDto,
          directorAddressResponseDto, companyPICResponseDtoList, accountInformationResponseDto, legalDocsDataResponseDto, photoDocumentResponseDto,
          supportingDocsResponseDto, registrationFormResponseDto, memberStatusResponseDto, additionalInformationResponse
        } = res.body.value
        commit('setCompanyInfoData', companyContactResponseDto)
        commit('setCompanyAddressData', companyAddressResponseDto)
        commit('setShippingAddressData', shippingAddressResponse)
        commit('setAppleAccountData', appleAccountResponseDto)
        commit('setSupportDocumentData', supportingDocsResponseDto)
        commit('setDirectorInfoData', directorInformationResponseDto)
        commit('setDirectorDocumentsData', directorDocumentsResponseDto)
        commit('setDirectorAddressData', directorAddressResponseDto)
        commit('setCompanyPicData', companyPICResponseDtoList)
        commit('setAccountInfoData', accountInformationResponseDto)
        commit('setDataDocumentsData', legalDocsDataResponseDto)
        commit('setPhotoDocumentsData', photoDocumentResponseDto)
        commit('setRegistrationDocumenstData', registrationFormResponseDto)
        commit('setMemberInfoData', memberStatusResponseDto)
        commit('setAdditionalInfoData', additionalInformationResponse)
        success && success(res.body.value)
      }).catch(err => {
        fail && fail(err)
      })
    },
    POST_REGISTER_DATA (_, { data, success, fail }) {
      resgistrationAPI.postRegisterData(data).then(res => {
        success && success(res.body)
      }).catch(err => {
        fail && fail(err)
      })
    },
    FILE_UPLOAD (_, { data, success, fail }) {
      resgistrationAPI.uploadFile(data).then(res => {
        success && success(res.body)
      }).catch(err => {
        fail && fail(err)
      })
    },
    COMPLETE_REGISTRATION_PROCESS (_, { data, success, fail }) {
      resgistrationAPI.completeRegistrationProcess(data).then(res => {
        success && success(res.body)
      }).catch(err => {
        fail && fail(err)
      })
    },
    GET_SECTION_TRACKING_DETAILS ({ commit }, { query, success, fail }) {
      return resgistrationAPI.getSectionTrackingDetails(query).then(res => {
        const {
          companyInfoTrackingResponseDto,
          directorTrackingResponseDto,
          accountInfoFlag,
          companyPicFlag,
          legalDocumentsTrackingResponseDto,
          registrationFormFlag,
          creditLimitFlag
        } = res.body.value
        commit('setSectionTrackingData', res.body.value)
        commit('setCompanyInfoResponse', companyInfoTrackingResponseDto)

        if (directorTrackingResponseDto) {
          const { directorOverAllFlag, directorContactFlag, directorDocumentsFlag } = directorTrackingResponseDto
          commit('setCompanyRepCompletedStatus', directorOverAllFlag)
          commit('setDirectorContactStatus', { completed: directorContactFlag, active: !directorContactFlag })
          commit('setDirectorPhotoStatus', { completed: directorDocumentsFlag, active: directorContactFlag && !directorDocumentsFlag })
        } else if (companyInfoTrackingResponseDto?.infoOverAllFlag) {
          commit('setDirectorContactStatus', { completed: false, active: true })
        }
        commit('setCompanyPicCompletedStatus', companyPicFlag)
        commit('setCompanyPicInfoStatus', { completed: companyPicFlag, active: directorTrackingResponseDto?.directorOverAllFlag && !companyPicFlag })

        if (legalDocumentsTrackingResponseDto) {
          const { legalDocOverAllFlag, dataAccToDocFlag, docPhotoFlag } = legalDocumentsTrackingResponseDto
          commit('setLegalDocumentsCompletedStatus', legalDocOverAllFlag)
          commit('setDataDocumentsStatus', { completed: dataAccToDocFlag, active: !dataAccToDocFlag })
          commit('setPhotoDocumentsActiveStatus', { completed: docPhotoFlag, active: dataAccToDocFlag && !docPhotoFlag })
        } else if (accountInfoFlag) {
          commit('setDataDocumentsStatus', { completed: false, active: true })
        }
        commit('setRegistrationDocumentCompletedStatus', registrationFormFlag)
        commit('setRegistrationFormStatus', { completed: registrationFormFlag, active: legalDocumentsTrackingResponseDto.legalDocOverAllFlag && !registrationFormFlag })

        commit('setCreditRequestCompletedStatus', creditLimitFlag)
        commit('setCreditRequestFormStatus', { completed: creditLimitFlag, active: registrationFormFlag && !creditLimitFlag })
        success && success(res.body.value)
      }).catch(err => {
        fail && fail(err)
      })
    }
  },
  namespaced: true
}
